import SpecificComponent from "../../commons/SpecificComponent";
import Utils from "../../providers/Utils";

export default class FinanciarFunctions {

    u = new Utils()


    getTotalVenituriBilant = (b) => {


        let totalVenituriIdx = b.bilanturi_rows.findIndex(br => br.descriere === 'VENITURI TOTALE (rd. 236 + 272)')


        // console.log('totalVenituriIdx :>> ', totalVenituriIdx);

        if (totalVenituriIdx !== -1) {
            console.log('  b.bilanturi_rows[totalVenituriIdx] :>> ', b.bilanturi_rows[totalVenituriIdx]);
            return b.bilanturi_rows[totalVenituriIdx]['sold_final']
        }

    }


    getTotalCheltuieli = (c) => {
        let totalCheltuieliIdx = c.bilanturi_rows.findIndex(br => br.descriere === 'CHELTUIELI TOTALE (rd. 262 + 279)')


        // console.log('totalCheltuieliIdx :>> ', totalCheltuieliIdx);

        if (totalCheltuieliIdx !== -1) {
            console.log('  b.bilanturi_rows[totalCheltuieliIdx] :>> ', c.bilanturi_rows[totalCheltuieliIdx]);
            return c.bilanturi_rows[totalCheltuieliIdx]['sold_final']
        }
    }


    getTotalProfitSauPierdere = (p) => {
        let totalProfitIdx = p.bilanturi_rows.findIndex(br => br.descriere === '- Profit (rd. 284 - 285 - 286 - 287)')


        if (totalProfitIdx !== -1) {

            console.log('c.bilanturi_rows[totalProfitIdx]sold_final :>> ', p.bilanturi_rows[totalProfitIdx]['sold_final']);
            if (p.bilanturi_rows[totalProfitIdx]['sold_final'] > 0) {
                return p.bilanturi_rows[totalProfitIdx]['sold_final']
            } else {

                let totalPierdereIdx = p.bilanturi_rows.findIndex(br => br.descriere === '- Pierdere (rd. 285 + 286 + 287 - 284)')

                if (totalPierdereIdx !== -1) {
                    return -p.bilanturi_rows[totalPierdereIdx]['sold_final']
                }
            }




        }
    }


    diferentaTotalVenituri = (b1, b2) => {

        let venituriB1 = this.getTotalVenituriBilant(b1)
        let venituriB2 = this.getTotalVenituriBilant(b2)


        let diferentaVenituri = (venituriB1 - venituriB2) / venituriB1 * 100

        return this.u.toFixedIfNecessary(diferentaVenituri, 2)


        console.log('diferentaVenituri :>> ', diferentaVenituri);




    }


    diferentaTotalCheltuieli = (b1, b2) => {

        let venituriB1 = this.getTotalCheltuieli(b1)
        let venituriB2 = this.getTotalCheltuieli(b2)


        let diferentaCheltuieli = (venituriB1 - venituriB2) / venituriB1 * 100
        console.log('diferentaCheltuieli :>> ', diferentaCheltuieli);

        return this.u.toFixedIfNecessary(diferentaCheltuieli, 2)


    }

    diferentaTotalProfit = (b1, b2) => {

        let venituriB1 = this.getTotalProfitSauPierdere(b1)
        let venituriB2 = this.getTotalProfitSauPierdere(b2)


        let diferentaProfit = (venituriB1 - venituriB2) / venituriB1 * 100
        console.log('diferentaProfit :>> ', diferentaProfit);

        return this.u.toFixedIfNecessary(diferentaProfit, 2)


    }


    mesajProfit = (b1, b2) => {

        let diferentaProfit = this.diferentaTotalProfit(b1, b2)

        let specificComponent = new SpecificComponent()

        let dict = specificComponent.dictionary


        if (diferentaProfit < 0) {
            return  dict.financiar.companiaEInPierdere
        } else if (diferentaProfit > 0 && diferentaProfit < 7) {
            return  dict.financiar.companiaEInProfitMediu
        } else {
            return dict.financiar.companiaEInProfit
        }


    }


    colorProfit = (b1, b2) => {
        let diferentaProfit = this.diferentaTotalProfit(b1, b2)


        if (diferentaProfit < 0) {
            return 'rgb(211 58	64)'
        } else if (diferentaProfit > 0 && diferentaProfit < 7) {
            return 'rgb(229	178	59)'
        } else {
            return 'rgb(24 165 58)'
        }
    }


    solduriClienti = (c) => {

        console.log('c :>> ', c);

        console.log('c.bilanturi_rows :>> ', c.bilanturi_rows);

        let solduriClienti = c.bilanturi_rows.findIndex(br => br.descriere === "Creante comerciale, avansuri pentru cumparari de bunuri de natura stocurilor ?i pentru prestari de servicii acordate furnizorilor si alte conturi asimilate, în sume brute (ct. 4091 + 4092 + 411 + 413 + 418), din care:")


        console.log('solduriClienti :>> ', solduriClienti);

        if (solduriClienti !== -1) {
            console.log('  b.bilanturi_rows[solduriClienti] :>> ', c.bilanturi_rows[solduriClienti]);

            return this.u.toFixedIfNecessary(c.bilanturi_rows[solduriClienti]['sold_final'], 2)
        
        }

    }

    solduriFurnizori = (c) => {

        console.log('c :>> ', c);

        console.log('c.bilanturi_rows :>> ', c.bilanturi_rows);

        let solduriFurnizori = c.bilanturi_rows.findIndex(br => br.descriere === "Datorii comerciale, avansuri primite de la clienti si alte conturi asimilate, în sume brute (ct. 401 + 403 + 404 + 405 + 408 + 419), din care:")


        console.log('solduriFurnizori :>> ', solduriFurnizori);

        if (solduriFurnizori !== -1) {
            console.log('  b.bilanturi_rows[solduriFurnizori] :>> ', c.bilanturi_rows[solduriFurnizori]);

            return this.u.toFixedIfNecessary(c.bilanturi_rows[solduriFurnizori]['sold_final'], 2)
            
   
        }

    }


    diferentaTotalSoldClienti = (b1, b2) => {

        let sold1 = this.solduriClienti(b1)
        let sold2 = this.solduriClienti(b2)

        console.log('b1 :>> ', b1);

        let diferentaCheltuieli = (sold1 - sold2) / sold1 * 100
        console.log('diferentaCheltuieli :>> ', diferentaCheltuieli);

        return this.u.toFixedIfNecessary(diferentaCheltuieli, 2)


    }

    diferentaTotalSoldFurnizori = (b1, b2) => {

        let sold1 = this.solduriFurnizori(b1)
        let sold2 = this.solduriFurnizori(b2)

        console.log('b1 :>> ', b1);

        let diferentaCheltuieli = (sold1 - sold2) / sold1 * 100
        console.log('diferentaCheltuieli :>> ', diferentaCheltuieli);

        return this.u.toFixedIfNecessary(diferentaCheltuieli, 2)


    }


    cashFlowCheltuieli = (b) => {


        let idxCheltuieli1 = b.bilanturi_rows.findIndex(br => br.descriere === "8. a)  Cheltuieli cu materiile prime si materialele consumabile (ct.601+602)")
        let idxCheltuieli2 = b.bilanturi_rows.findIndex(br => br.descriere === "Alte cheltuieli materiale (ct.603+604+606+608)")
        let idxCheltuieli3 = b.bilanturi_rows.findIndex(br => br.descriere === "b) Alte cheltuieli externe (cu energie si apa)(ct.605)")
        let idxCheltuieli4 = b.bilanturi_rows.findIndex(br => br.descriere === "c) Cheltuieli privind marfurile (ct.607)")
        let idxCheltuieli5 = b.bilanturi_rows.findIndex(br => br.descriere === "Reduceri comerciale primite (ct. 609)")


        console.log('idxCheltuieli1 :>> ', idxCheltuieli1);
        console.log('idxCheltuieli2 :>> ', idxCheltuieli2);
        console.log('idxCheltuieli3 :>> ', idxCheltuieli3);
        console.log('idxCheltuieli4 :>> ', idxCheltuieli4);
        console.log('idxCheltuieli5 :>> ', idxCheltuieli5);


        if (idxCheltuieli1 !== -1 && idxCheltuieli2 !== -1 && idxCheltuieli3 !== -1 && idxCheltuieli4 !== -1 && idxCheltuieli5 !== -1) {

            let sum = b.bilanturi_rows[idxCheltuieli1]['sold_final'] + b.bilanturi_rows[idxCheltuieli2]['sold_final'] + b.bilanturi_rows[idxCheltuieli3]['sold_final'] + b.bilanturi_rows[idxCheltuieli4]['sold_final'] +  b.bilanturi_rows[idxCheltuieli5]['sold_final']


            return this.u.toFixedIfNecessary(sum, 2)
        }




    }

    cashFlowCosturi = (b) => {


        let idxCosturi1 = b.bilanturi_rows.findIndex(br => br.descriere === "9. Cheltuieli cu personalul (rd. 243 + 244)")
        let idxCosturi2 = b.bilanturi_rows.findIndex(br => br.descriere === "10.a) Ajustari de valoare privind imobilizarile corporale si necorporale (rd. 246 - 247)")
        let idxCosturi3 = b.bilanturi_rows.findIndex(br => br.descriere === "b) Ajustari de valoare privind activele circulante (rd. 249 - 250)")
        let idxCosturi4 = b.bilanturi_rows.findIndex(br => br.descriere === "11. Alte cheltuieli de exploatare (rd. 252 la 258)")


        console.log('idxCosturi1 :>> ', idxCosturi1);
        console.log('idxCosturi2 :>> ', idxCosturi2);
        console.log('idxCosturi3 :>> ', idxCosturi3);
        console.log('idxCosturi4 :>> ', idxCosturi4);


        if (idxCosturi1 !== -1 && idxCosturi2 !== -1 && idxCosturi3 !== -1 && idxCosturi4 !== -1) {

            let sum = b.bilanturi_rows[idxCosturi1]['sold_final'] + b.bilanturi_rows[idxCosturi2]['sold_final'] + b.bilanturi_rows[idxCosturi3]['sold_final'] + b.bilanturi_rows[idxCosturi4]['sold_final']


            return this.u.toFixedIfNecessary(sum, 2)
        }




    }


    fluxulDeNumerar = (b) =>{

        let venituri = this.getTotalVenituriBilant(b)
        let costuri = this.cashFlowCosturi(b)
        let cheltuieli = this.cashFlowCheltuieli(b)


        let fluxNumerar = venituri - costuri - cheltuieli
        console.log('fluxulNumerar :>> ', fluxNumerar);

        return this.u.toFixedIfNecessary(fluxNumerar, 2)
    }



    calculPrognoza = (b) =>{

        let bEl = b.length

        console.warn('bEl :>> ', bEl);

        let sumAni = 0

        for(let i = bEl-1 ; i > 0 ; i = i - 1){

            console.warn('i', i)

            console.warn('venituri an 1', this.getTotalVenituriBilant(b[i]) )
            console.warn('venituri an 2', this.getTotalVenituriBilant(b[i - 1]) )
            sumAni += (this.getTotalVenituriBilant(b[i]) - this.getTotalVenituriBilant(b[i-1]))
        }

        console.log('sumAni :>> ', sumAni);

        let mA = sumAni / (bEl -1)

        

        // let val1 = this.getTotalVenituriBilant(b[b.length - 1])

        // let val2 =  this.getTotalVenituriBilant(b[0])

        // let mA = (val1 - val2) / bEl - 1

        console.log('mA :>> ', mA);

        return this.u.toFixedIfNecessary(mA, 2)
        
    }

    calculPrognozaCheltuieli = (b) =>{

        let bEl = b.length

        console.warn('bEl :>> ', bEl);

        let sumAni = 0

        for(let i = bEl-1 ; i > 0 ; i = i - 1){

            console.warn('i', i)

            console.warn('venituri an 1', this.getTotalCheltuieli(b[i]) )
            console.warn('venituri an 2', this.getTotalCheltuieli(b[i - 1]) )
            sumAni += (this.getTotalCheltuieli(b[i]) - this.getTotalCheltuieli(b[i-1]))
        }

        console.log('sumAni :>> ', sumAni);

        let mA = sumAni / (bEl -1)

        

        // let val1 = this.getTotalVenituriBilant(b[b.length - 1])

        // let val2 =  this.getTotalVenituriBilant(b[0])

        // let mA = (val1 - val2) / bEl - 1

        console.log('mA :>> ', mA);

        return this.u.toFixedIfNecessary(mA, 2)
        
    }


    getMarja = (m) => {
        let marjaComercialaIdx = m.bilanturi_rows.findIndex(br => br.descriere === "Venituri din vânzarea marfurilor (ct. 707)")
        let marjaComercialaIdx2 = m.bilanturi_rows.findIndex(br => br.descriere === "c) Cheltuieli privind marfurile (ct.607)")

        console.log('marjaComercialaIdx :>> ', marjaComercialaIdx);

        if (marjaComercialaIdx !== -1 && marjaComercialaIdx2 !== -1)  {
            console.log('  b.bilanturi_rows[marjaComercialaIdx] :>> ', m.bilanturi_rows[marjaComercialaIdx]);

            let marja = m.bilanturi_rows[marjaComercialaIdx]['sold_final'] -  m.bilanturi_rows[marjaComercialaIdx2]['sold_final']

            return this.u.toFixedIfNecessary(marja, 2)
            
           
        }
    }


    productiaExercitiului = (p) =>{

     
        // = randul 465 din bilant + 471 - 472 + 473

        let pEidx = p.bilanturi_rows.findIndex(br => br.descriere === "Productia  vânduta  (ct.701+702+703+704+705+706+708)")
        let pEidx2 = p.bilanturi_rows.findIndex(br => br.descriere === "Sold C")
        let pEidx3 = p.bilanturi_rows.findIndex(br => br.descriere === "Sold D")
        let pEidx4 = p.bilanturi_rows.findIndex(br => br.descriere === "3.  Venituri din productia de imobilizari necorporale si corporale (ct.721+ 722)")


        if(pEidx !== -1 && pEidx2 !== -1 && pEidx3 !== -1 && pEidx4 !== -1){
            let pE = p.bilanturi_rows[pEidx]['sold_final'] +  p.bilanturi_rows[pEidx2]['sold_final'] -  p.bilanturi_rows[pEidx3]['sold_final'] +  p.bilanturi_rows[pEidx4]['sold_final']
            return this.u.toFixedIfNecessary(pE, 2)
          
        }

    }


    valoareAdaugata = (v) =>{

        //  randul 464 - randul 485 - randul 482

        let vAidx = v.bilanturi_rows.findIndex(br => br.descriere === "1. Cifra de afaceri neta (rd. 222+223-224+225+226)")
        let vAidx2 = v.bilanturi_rows.findIndex(br => br.descriere === "c) Cheltuieli privind marfurile (ct.607)")
        let vAidx3 = v.bilanturi_rows.findIndex(br => br.descriere === "8. a)  Cheltuieli cu materiile prime si materialele consumabile (ct.601+602)")
        let vAidx4 = v.bilanturi_rows.findIndex(br => br.descriere === "Alte cheltuieli materiale (ct.603+604+606+608)")
        let vAidx5 = v.bilanturi_rows.findIndex(br => br.descriere === "b) Alte cheltuieli externe (cu energie si apa)(ct.605)")

        


        if(vAidx !== -1 && vAidx2 !== -1 && vAidx3 !== -1 && vAidx4 !== -1 && vAidx5 !== -1){

            let vA = v.bilanturi_rows[vAidx]['sold_final'] - v.bilanturi_rows[vAidx2]['sold_final'] - v.bilanturi_rows[vAidx3]['sold_final'] - v.bilanturi_rows[vAidx4]['sold_final'] - v.bilanturi_rows[vAidx5]['sold_final']

          

            return this.u.toFixedIfNecessary(vA, 2)
        }


    }

    excedentBrutDinExploatare = (e) =>{


        // valoare adaugata + randul 478 - randul 490- randul 493 - 496
       

        let eBidx = e.bilanturi_rows.findIndex(br => br.descriere === "7. Alte venituri din exploatare (ct.751+758+7815)")
        let eBidx2 = e.bilanturi_rows.findIndex(br => br.descriere === "10.a) Ajustari de valoare privind imobilizarile corporale si necorporale (rd. 246 - 247)")
        let eBidx3 = e.bilanturi_rows.findIndex(br => br.descriere === "b) Ajustari de valoare privind activele circulante (rd. 249 - 250)")
        let eBidx4 = e.bilanturi_rows.findIndex(br => br.descriere === "11. Alte cheltuieli de exploatare (rd. 252 la 258)")



      


        if(eBidx !== -1 && eBidx2 !== -1 && eBidx3 !== -1){

            let eB =this.valoareAdaugata(e) + e.bilanturi_rows[eBidx]['sold_final'] - e.bilanturi_rows[eBidx2]['sold_final']  - e.bilanturi_rows[eBidx3]['sold_final'] -  e.bilanturi_rows[eBidx4]['sold_final']

        

            return this.u.toFixedIfNecessary(eB, 2)
        }
 

        


    }

    rezultatDinExploatare = (e) =>{
        //  excedent brut din exploatare - randul 490


        let rEidx = e.bilanturi_rows.findIndex(br => br.descriere === "10.a) Ajustari de valoare privind imobilizarile corporale si necorporale (rd. 246 - 247)")


        if(rEidx !== -1){

            let rE = this.excedentBrutDinExploatare(e) - e.bilanturi_rows[rEidx]['sold_final']

           

            return this.u.toFixedIfNecessary(rE, 2)
        }
    }


    rezultatulBrutAlExercitiului = (e) =>{
        // rezultatul din exploatare + randul 528

        let rEidx = e.bilanturi_rows.findIndex(br => br.descriere === "- Profit (rd. 272 - 279)")


        if(rEidx !== -1){
            let rE = this.rezultatDinExploatare(e) - e.bilanturi_rows[rEidx]['sold_final']

       
            return this.u.toFixedIfNecessary(rE, 2)

        }

    }

    rezultatulNetAlExercitiului = (e) =>{

        //  rezultatul brut al exercitiului - randul 535 - randul 536


        let rEidx = e.bilanturi_rows.findIndex(br => br.descriere === "19.  Impozitul pe profit (ct. 691)")
        let rEidx2 = e.bilanturi_rows.findIndex(br => br.descriere === "20.  Alte impozite neprezentate la elementele de mai sus (ct. 698)")



        if(rEidx !== -1 && rEidx2 !== -1){

            let rE = this.rezultatulBrutAlExercitiului(e) - e.bilanturi_rows[rEidx]['sold_final'] -  e.bilanturi_rows[rEidx2]['sold_final']

            return this.u.toFixedIfNecessary(rE, 2)
         
        }


    }

    rataRentabilitatiiEconomice = (r) =>{

        // rezultatul net al exercitiului / (randu 97 + randul 103 + randul 105 ) * 100 ----pagina 13  interpretare din word

        let rRidx = r.bilanturi_rows.findIndex(br => br.descriere === "ACTIVE IMOBILIZATE - TOTAL (rd. 01 + 02 + 03)")
        let rRidx2 = r.bilanturi_rows.findIndex(br => br.descriere === "ACTIVE CIRCULANTE - TOTAL (rd. 05 + 06 + 07 + 08)")
        let rRidx3 = r.bilanturi_rows.findIndex(br => br.descriere === "Sume de reluat într-o perioada de pâna la un an (din ct. 471*)")

        if(rRidx !== -1 && rRidx2 !== -1 && rRidx3 !== -1){

            let rE = (this.rezultatulNetAlExercitiului(r) / (r.bilanturi_rows[rRidx]['sold_final'] + r.bilanturi_rows[rRidx2]['sold_final'] + r.bilanturi_rows[rRidx3]['sold_final'])) * 100

            return this.u.toFixedIfNecessary(rE, 2)
        }


    }


    tendintaRentabilitatiiEconomice = (r1, r2) =>{

        let rE1 = this.rataRentabilitatiiEconomice(r1)
        let rE2 = this.rataRentabilitatiiEconomice(r2)

        console.log('rE1 :>> ', rE1);
        console.log('rE2 :>> ', rE2);

        let rEfinal = (rE2 - rE1) / rE1

    

        return this.u.toFixedIfNecessary(rEfinal, 2)
    }


    rataRentabilitatiiFinanciare = (r) =>{

        // rezultatul net al exercitiului / randu 143 * 100

        let rRidx = r.bilanturi_rows.findIndex(br => br.descriere === "CAPITALURI PROPRII - TOTAL (rd. 29+35+36+37-38+39-40+41-42+43-44-45)")

        if(rRidx !== -1){

            let rE = (this.rezultatulNetAlExercitiului(r) / r.bilanturi_rows[rRidx]['sold_final']) * 100

         

            return this.u.toFixedIfNecessary(rE, 2)
        }


    }

    tendintaRentabilitatiiFinanciare = (r1, r2) =>{

        let rE1 = this.rataRentabilitatiiFinanciare(r1)
        let rE2 = this.rataRentabilitatiiFinanciare(r2)

        console.log('rE1 :>> ', rE1);
        console.log('rE2 :>> ', rE2);

        let rEfinal = (rE2 - rE1) / rE1

 

        return this.u.toFixedIfNecessary(rEfinal, 2)
    }


    rataProfituluiBrut = (r) =>{
        //  profitul brut ( randul 533 bilant) / (randul 482 + randul 487) * 100

        let rRidx = r.bilanturi_rows.findIndex(br => br.descriere === "- Profit (rd. 282 - 283)")
        let rRidx2 = r.bilanturi_rows.findIndex(br => br.descriere === "8. a)  Cheltuieli cu materiile prime si materialele consumabile (ct.601+602)")
        let rRidx3 = r.bilanturi_rows.findIndex(br => br.descriere === "9. Cheltuieli cu personalul (rd. 243 + 244)")


        if(rRidx !== -1 && rRidx2 !== -1 && rRidx3 !== -1){

            let rPFinal = r.bilanturi_rows[rRidx]['sold_final'] / (r.bilanturi_rows[rRidx2]['sold_final'] + r.bilanturi_rows[rRidx3]['sold_final']) * 100

           

            return this.u.toFixedIfNecessary(rPFinal, 2)
        }


        

    }


    marjaNetaAProfitului = (r) =>{
        //  profitul net (538) / cifra de afaceri 464 * 100

        let rRidx = r.bilanturi_rows.findIndex(br => br.descriere === "- Profit (rd. 284 - 285 - 286 - 287)")
        let rRidx2 = r.bilanturi_rows.findIndex(br => br.descriere === "1. Cifra de afaceri neta (rd. 222+223-224+225+226)")


        if(rRidx !== -1 && rRidx2 !== -1 ){

            let rPFinal = r.bilanturi_rows[rRidx]['sold_final'] / r.bilanturi_rows[rRidx2]['sold_final']  * 100

          

            return this.u.toFixedIfNecessary(rPFinal, 2)
        }


        

    }


    analizaStocurilor = (b1,b2) =>{

        let specificComponent = new SpecificComponent()

        let dict = specificComponent.dictionary


        let idxS1 = b1.bilanturi_rows.findIndex(br => br.descriere === "I.   STOCURI   (ct.301+302+303+321+322+/-308+323+326+327+328+331+332+341+345+346+347+/-348+351+354+356+357+358+361+/-368+371+/-378+381+/-388+4091- 391- 392-393-394-395-396-397-398 - din ct.4428)")
        let idxS2 = b2.bilanturi_rows.findIndex(br => br.descriere === "I.   STOCURI   (ct.301+302+303+321+322+/-308+323+326+327+328+331+332+341+345+346+347+/-348+351+354+356+357+358+361+/-368+371+/-378+381+/-388+4091- 391- 392-393-394-395-396-397-398 - din ct.4428)")
        

        if(idxS1 !== -1 && idxS2 !== -1){

            if(  b1.bilanturi_rows[idxS1]['sold_final'] > b2.bilanturi_rows[idxS2]['sold_final']){
                return dict.financiar.buna
            }else{
                return dict.financiar.rea
            }

          
        }


    }

    vitezaDeRotatieAStocurilor = (b) =>{
        //cifra de afaceri (randul 464) / stocuri (randul 99)

        let idxV = b.bilanturi_rows.findIndex(br => br.descriere === "1. Cifra de afaceri neta (rd. 222+223-224+225+226)")
        let idxV2 = b.bilanturi_rows.findIndex(br => br.descriere === "I.   STOCURI   (ct.301+302+303+321+322+/-308+323+326+327+328+331+332+341+345+346+347+/-348+351+354+356+357+358+361+/-368+371+/-378+381+/-388+4091- 391- 392-393-394-395-396-397-398 - din ct.4428)")
        


        if(idxV !== -1 && idxV2 !== -1){

            let vFinal = b.bilanturi_rows[idxV]['sold_final'] / b.bilanturi_rows[idxV2]['sold_final']

            return this.u.toFixedIfNecessary(vFinal, 2)
        }



    }



}


